<template>
  <router-view class="" v-if="ready" />
</template>

<script>

export default {
  components: {},
  data: () => ({
    ready: true,
  }),
  beforeMount() {
   
  },
  methods: {
  
  },
};
</script>